import React from 'react';
import CSHubImage from '../../../assets/projectsImage/csHubImages/CSHub.jpg';
import CSHubImage2 from '../../../assets/projectsImage/csHubImages/CSHub2.jpg';
import CSHubImage3 from '../../../assets/projectsImage/csHubImages/CSHub3.jpg';
import CSHubImage4 from '../../../assets/projectsImage/csHubImages/CSHub4.jpg';
import reactLogoImage from '../../../assets/technologyLogo/react.png';
import reactRouterDomLogoImage from '../../../assets/technologyLogo/reactRouterDom.png';
import firebaseLogoImage from '../../../assets/technologyLogo/firebase.png';
import tailwindLogoImage from '../../../assets/technologyLogo/tailwind-css.png';
import nodeLogoImage from '../../../assets/technologyLogo/node.png';
import expressLogoImage from '../../../assets/technologyLogo/express.png';
import { PhotoProvider, PhotoView } from 'react-photo-view';

const CSHub = () => {
    return (
        <section className='mt-12'>
            <div className='md:mx-0 mx-5'>
                <h1 className='text-5xl font-bold text-center' style={{ color: '#65647C' }}>Project Name: CS Hub Website</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-5 mb-10"></hr>
            </div>
            {/* live link, github link */}
            <div className='flex justify-center items-center mb-20 md:mx-0 mx-5'>
                <a href='https://cs-hub-website.web.app/' target="_blank" rel="noopener noreferrer" type="button" className="w-40 text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br shadow-lg shadow-blue-500/50  font-medium rounded-lg md:text-base text-xs px-2 py-2.5 text-center md:mr-10 mr-5">Live Website</a>
                <a href='https://github.com/EhsanEIK/cs-hub-website-client' target="_blank" rel="noopener noreferrer" type="button" className="w-40 text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br shadow-lg shadow-green-500/50 font-medium rounded-lg md:text-base text-xs px-2 py-2.5 text-center md:mr-10 mr-5">Github Client</a>
                <a href='https://github.com/EhsanEIK/cs-hub-website-server' target="_blank" rel="noopener noreferrer" type="button" className="w-40 text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br shadow-lg shadow-cyan-500/50 font-medium rounded-lg md:text-base text-xs px-2 py-2.5 text-center">Github Server</a>
            </div>

            <PhotoProvider speed={() => 700}
                easing={(type) => (type === 2 ? 'cubic-bezier(0.36, 0, 0.66, -0.56)' : 'cubic-bezier(0.34, 1.56, 0.64, 1)')}>
                <div className='flex md:flex-row flex-col justify-center items-center gap-x-20 md:gap-y-0 gap-y-10'>
                    <PhotoView key="01" src={CSHubImage}>
                        <img src={CSHubImage} alt="CSHubImage" className='w-56 h-auto border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                    </PhotoView>
                    <PhotoView key="02" src={CSHubImage2}>
                        <img src={CSHubImage2} alt="CSHubImage2" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                    </PhotoView>
                    <PhotoView key="03" src={CSHubImage3}>
                        <img src={CSHubImage3} alt="CSHubImage3" className='w-56 h-auto border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                    </PhotoView>
                    <PhotoView key="04" src={CSHubImage4}>
                        <img src={CSHubImage4} alt="CSHubImage4" className='w-56 h-56 border border-teal-500 rounded-lg p-1 hover:cursor-pointer' />
                    </PhotoView>
                </div>
            </PhotoProvider>

            {/* Technology */}
            <div>
                <h1 className='text-4xl font-bold text-center mt-28' style={{ color: '#65647C' }}>Technology</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-5 mb-10"></hr>
                {/* front-end */}
                <div>
                    <h3 className='bg-indigo-300 text-2xl font-bold italic text-center p-5 md:mx-0 mx-3 mt-5 mb-10'>Front-End</h3>
                    <div className='flex md:flex-row flex-col justify-center items-center gap-10'>
                        <img src={reactLogoImage} alt="reactLogoImage" className='w-60' />
                        <img src={reactRouterDomLogoImage} alt="reactRouterDomLogoImage" className='w-60' />
                        <img src={firebaseLogoImage} alt="firebaseLogoImage" className='w-60' />
                        <img src={tailwindLogoImage} alt="tailwindLogoImage" className='w-60' />
                    </div>
                </div>
                {/* back-end */}
                <div>
                    <h3 className='bg-indigo-300 text-2xl font-bold italic text-center p-5 md:mx-0 mx-3 mt-20 mb-10'>Back-End</h3>
                    <div className='flex md:flex-row flex-col justify-center items-center gap-10'>
                        <img src={nodeLogoImage} alt="nodeLogoImage" className='w-60' />
                        <img src={expressLogoImage} alt="expressLogoImage" className='w-60' />
                    </div>
                </div>
            </div>

            {/* Features */}
            <div>
                <h1 className='text-4xl font-bold text-center mt-28' style={{ color: '#65647C' }}>Features</h1>
                <hr className="h-px bg-gray-300 border-0 dark:bg-gray-700 mt-5 mb-10"></hr>
                <ul className='list-disc text-xl font-medium md:mx-20 mx-10'>
                    <li className='mt-5'>When you visit another link/route on this website, it will take you to that page without reloading the site.</li>
                    <li className='mt-5'>User can register new account with email & password, And can sign in via email & password, google account and github account.</li>
                    <li className='mt-5'>If user visit protected route(for accessing premium service) without sign in, the page will redirect the user to the sign in page and after signing in he will get back to the previous existing route, and to access premium service user must need to sign in/sign up a new account.</li>
                    <li className='mt-5'>User can download the pdf format of course details.</li>
                    <li className='mt-5'>Here also a special feature of dark mode and light mode in the website.</li>
                    <li className='mt-5'>The website title is dynamic. That is , when you visit any page, the title will show you the existing page name in the title of the website.</li>
                    <li className='mt-5'>Created api for getting data from server to client. (Server Side)</li>
                    <li className='mt-5'>Added CORS to get data to client site.</li>
                </ul>
            </div>
        </section >
    );
};

export default CSHub;